import { Field } from '../questionnaireHelpers';

export default function indexFailedFields(fields: Field[]) {
	return fields.map(field => {
		if (!field?.index) {
			return { index: 0, ...field };
		}
		return field;
	});
}
